module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "py-0"
  }, [_c('div', [_c('v-card', {
    staticClass: "pb-2",
    staticStyle: {
      "border": "none",
      "min-height": "100vh"
    },
    attrs: {
      "flat": ""
    }
  }, [_c('h2', {
    staticClass: "pt-2 mx-2 text-xs-center"
  }, [_c('span', {
    staticStyle: {
      "color": "#065694"
    }
  }, [_vm._v("TRA CỨU THÔNG TIN HỒ SƠ ")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "mx-2 mt-2 px-0 py-0",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "px-3 py-3",
    staticStyle: {
      "max-width": "700px",
      "margin": "0 auto",
      "border": "1px solid #dddddd"
    },
    attrs: {
      "color": "#002c46b3",
      "flat": ""
    }
  }, [_c('v-form', {
    ref: "form",
    staticClass: "mt-2",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "solo": "",
      "placeholder": "Mã số hồ sơ",
      "prepend-inner-icon": "description",
      "height": "42"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filterDossier($event)
      }
    },
    model: {
      value: (_vm.dossierNoKey),
      callback: function($$v) {
        _vm.dossierNoKey = $$v
      },
      expression: "dossierNoKey"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "solo": "",
      "placeholder": "Số CMTND/ Hộ chiếu",
      "prepend-inner-icon": "credit_card",
      "height": "42"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filterDossier($event)
      }
    },
    model: {
      value: (_vm.applicantIdNoKey),
      callback: function($$v) {
        _vm.applicantIdNoKey = $$v
      },
      expression: "applicantIdNoKey"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-left text-xs-center mt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ml-0 mr-1 my-0 white--text",
    attrs: {
      "color": "#0b72ba",
      "loading": _vm.loadingTable,
      "disabled": _vm.loadingTable
    },
    on: {
      "click": _vm.filterDossier
    }
  }, [_c('v-icon', [_vm._v("search")]), _vm._v(" \n                  Tra cứu\n                ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-1 my-0 white--text",
    attrs: {
      "color": "#0b72ba",
      "loading": _vm.loading,
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('v-icon', [_vm._v("reply")]), _vm._v(" \n                  Quay lại\n                ")], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-width": "1300px",
      "margin": "0 auto"
    }
  }, [_c('v-flex', {
    staticClass: "mt-3 mx-3"
  }, [_c('v-toolbar', {
    attrs: {
      "height": "42",
      "color": "#0b72ba",
      "dark": "",
      "flat": ""
    }
  }, [(!_vm.activeDetailDossier) ? _c('v-toolbar-title', {
    staticStyle: {
      "font-size": "16px !important"
    }
  }, [_vm._v("Kết quả tìm kiếm "), _c('span', [_vm._v(": " + _vm._s(_vm.dossierList.length) + " hồ sơ")])]) : _c('v-toolbar-title', {
    staticStyle: {
      "font-size": "16px !important"
    }
  }, [_vm._v("Thông tin chi tiết hồ sơ")])], 1)], 1), _vm._v(" "), (_vm.validateTracuu === true && !_vm.activeDetailDossier) ? _c('div', {
    staticClass: "mx-3 mt-4",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-data-table', {
    staticClass: "table-landing table-bordered",
    attrs: {
      "headers": _vm.headersTable,
      "items": _vm.dossierList,
      "hide-actions": "",
      "id": "tracuuhoso"
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "hover-pointer",
          class: {
            'active': props.index % 2 == 1
          },
          on: {
            "click": function($event) {
              return _vm.viewDetail(props.item)
            }
          }
        }, [_c('td', {
          staticClass: "text-xs-center py-3",
          attrs: {
            "width": "50px"
          }
        }, [(_vm.loadingTable) ? _c('content-placeholders', [_c('content-placeholders-text', {
          attrs: {
            "lines": 1
          }
        })], 1) : _c('div', [_c('span', [_vm._v(_vm._s(props.index + 1))]), _c('br')])], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left py-3"
        }, [(_vm.loadingTable) ? _c('content-placeholders', [_c('content-placeholders-text', {
          attrs: {
            "lines": 1
          }
        })], 1) : _c('div', [_c('span', [_vm._v(_vm._s(props.item.dossierNo))]), _c('br')])], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left py-3"
        }, [(_vm.loadingTable) ? _c('content-placeholders', [_c('content-placeholders-text', {
          attrs: {
            "lines": 1
          }
        })], 1) : _c('div', [_c('span', [_vm._v(_vm._s(props.item.applicantName))])])], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left py-3"
        }, [(_vm.loadingTable) ? _c('content-placeholders', [_c('content-placeholders-text', {
          attrs: {
            "lines": 1
          }
        })], 1) : _c('div', [_c('span', [_c('span', [_vm._v(_vm._s(props.item.receiveDate))])])])], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left py-3"
        }, [(_vm.loadingTable) ? _c('content-placeholders', [_c('content-placeholders-text', {
          attrs: {
            "lines": 1
          }
        })], 1) : _c('div', [_c('span', [_vm._v(_vm._s(props.item.dossierStatusText))])])], 1)])]
      }
    }], null, false, 269305121)
  }, [_vm._v(" "), _c('template', {
    slot: "no-data"
  }, [_c('div', {
    staticClass: "text-xs-center mt-2"
  }, [_vm._v("\n                Không có hồ sơ nào được tìm thấy\n              ")])])], 2), _vm._v(" "), (_vm.totalPages > 10) ? _c('div', {
    staticClass: "text-xs-center layout wrap mt-2",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "flex pagging-table px-2"
  }, [_c('tiny-pagination', {
    attrs: {
      "total": _vm.totalPages,
      "page": _vm.hosoDatasPage,
      "custom-class": "custom-tiny-class"
    },
    on: {
      "tiny:change-page": _vm.paggingData
    }
  })], 1)]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.validateTracuu === true && _vm.activeDetailDossier) ? _c('div', {
    staticClass: "mx-3 mt-0",
    staticStyle: {
      "border": "1px solid #0b72ba"
    }
  }, [_c('chi-tiet-ho-so', {
    attrs: {
      "index": _vm.dossierDetail.dossierId
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "290"
    },
    model: {
      value: (_vm.dialogError),
      callback: function($$v) {
        _vm.dialogError = $$v
      },
      expression: "dialogError"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Bạn không có quyền truy cập hồ sơ \n          "), _c('span', [_vm._v(_vm._s(_vm.dossierDetail.dossierNo))])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogError = false
      }
    }
  }, [_vm._v("Đồng ý")])], 1)], 1)], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-28f0c43f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28f0c43f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TraCuuHomePage.vue
// module id = 524
// module chunks = 1